import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Capability, useCapabilities } from '@/hooks/useCapabilities';

import { type Pipeline, PIPELINE_LABELS } from './osintConstantineConstants';

interface PipelineSelectProps {
  value: Pipeline;
  onValueChange: (value: Pipeline) => void;
  disabled?: boolean;
}

export function PipelineSelect({
  value,
  onValueChange,
  disabled,
}: PipelineSelectProps) {
  // Pull pipeline options from the constantine capability manifest — same
  // source the Attacks CapabilityDrawer uses (filter by name, then match).
  const { data: capabilities = [], status } = useCapabilities({
    name: 'constantine',
  });

  const constantine = capabilities.find(
    (cap: Capability) => cap.name === 'constantine'
  );
  const options =
    constantine?.parameters?.find(p => p.name === 'pipeline')?.options ?? [];

  const isLoading = status === 'pending';
  const noOptions = options.length === 0;

  return (
    <div>
      <span className="text-chariot-text-primary mb-1 block text-sm font-medium">
        Run Tier
      </span>
      <Select
        value={value}
        onValueChange={val => onValueChange(val as Pipeline)}
        disabled={disabled || isLoading || noOptions}
      >
        <SelectTrigger aria-label="Run Tier">
          <SelectValue
            placeholder={isLoading ? 'Loading…' : 'Select pipeline...'}
          />
        </SelectTrigger>
        <SelectContent>
          {options.map(opt => (
            <SelectItem key={opt} value={opt}>
              {PIPELINE_LABELS[opt] ?? opt}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-chariot-text-secondary mt-1 text-xs">
        Premium runs the deepest analysis; Basic is fastest and cheapest.
      </p>
    </div>
  );
}
